<div>

    <div class="row my-5 projection__table">
        <div class="col-5 col-md-4 table-side-container">
            <div class="header top"></div>
            <div class="header">Revenue</div>
            <div class="header">Net Income + Owner’s Salary</div>
        </div>

        <div class="col-7 col-md-8">
            <div class="row flex-nowrap table__body border__bottom custom__scroll vertical__Scroll overflow-y-hidden">
                <div class="col-lg-3 col-md-6 col-8 p-0 table-column" *ngFor="let ist of fpIst; let i = index">

                    <div class="table-column-header">
                        <div>{{ist.YEAR}}</div>
                        <div class="color-secondary-gray font-size-12">
                            {{reportService.changeTextStyle(ist.FINANCIAL_TYPE)}}</div>
                    </div>

                    <ng-container *ngIf="ist.FINANCIAL_TYPE != 'NOT_AVAILABLE'">

                        <div class="table-column-cell">
                            <div class="d-flex align-items-center">
                                <div class="w-60">
                                    <div class="input silent-input">{{ist.REVENUE | number}}</div>
                                </div>
                                <ng-container *ngIf="i">
                                    <ist-margin [revenue]="getPreviousYearRevenue(i)" [fieldValue]="ist.REVENUE" [isWeightingPage]="true"></ist-margin>
                                </ng-container>
                            </div>
                        </div>

                        <div class="table-column-cell">
                            <div class="d-flex align-items-center">
                                <div class="w-60">
                                    <div class="input silent-input">
                                        {{calculateTotal(ist) | number}}
                                    </div>
                                </div>
                                <ist-margin [revenue]="ist.REVENUE" [fieldValue]="calculateTotal(ist)"
                                    [selectedMonth]="getSelectedMonth(ist)"></ist-margin>
                            </div>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="ist.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                        <div class="table-column-cell">
                            <div class="d-flex align-items-center">
                                <div class="input silent-input">0</div>
                            </div>
                        </div>
                        <div class="table-column-cell">
                            <div class="d-flex align-items-center">
                                <div class="input silent-input">0</div>
                            </div>
                        </div>
                    </ng-container>


                </div>
            </div>
        </div>

    </div>

    <form #futureProjectionsForm="ngForm" novalidate="novalidate" autocomplete="off">
        <!-- #region "future-year" -->
        <div class="row my-5 FUTURE__PROJECTIONS__PAGE justify-content-md-center" *ngIf="currentReport?.LATEST">
            <div class="col-lg-10 col-md-12">

                <div class="d-flex align-items-center justify-content-between">
                    <div class="label">
                        Does the most recent year's sales represent a good indication of how the Company will perform
                        in the future?
                    </div>
                    <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                </div>
              <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                If you select “No”, this report will utilize a forward looking Discounted Cash Flow (DCF) method and you will be asked to enter projected Revenues for the next three years (a Projections screen will appear after the Adjustments section).
              </div>

                <div class="row m-0">
                    <div class="col-md-12 p-0">
                        <radio-group-button [selectedOption]="currentReport.LATEST.INTERIM_FUTURE_INDICATION"
                            [btnList]="indicationOption" [isButton]="true"
                                            [disabled]="currentReport?.isLocked"
                            [(ngModel)]="currentReport.LATEST.INTERIM_FUTURE_INDICATION"
                            #INTERIM_FUTURE_INDICATION="ngModel" name="INTERIM_FUTURE_INDICATION"
                            id="INTERIM_FUTURE_INDICATION" required
                            (optionChange)="currentReport.LATEST.INTERIM_FUTURE_INDICATION = $event; callUpdateVersionDetailsAPI('INTERIM_FUTURE_INDICATION')">
                        </radio-group-button>
                    </div>
                </div>

            </div>
        </div>
        <!-- #endregion -->
    </form>
</div>


<report-footer [nextBtnEnable]="!futureProjectionsForm.invalid"
    (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.FUTURE_PROJECTION">
</report-footer>
